import React from 'react';
import { Formik, Form, Field } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as dataSeed from '../shared/DataSeed';
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert,
    Fade, ModalHeader
} from 'reactstrap';
import { bankValidationActions } from '../store/BcaValidation.Reducer';
import 'react-html5-camera-photo/build/css/index.css';
import * as Yup from "yup";

class BankValidation extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            load: false,
            error: false,
            success: -1,
            message: 'Gagal Validasi',
            bankValidationCode: localStorage.getItem('bankValidationCode') || '',
            kepemilikanAsset: localStorage.getItem('kepemilikanAsset') || '1',
            agreementCheck: false,
            agreementBO: false,
            agreementBCA: false,
            validationCode: '',
            isLoading: false,
            openModal: false,
            fotoSpecimen: '',
            imageHash: '',//Date.now(),
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleValidateClick = this.handleValidateClick.bind(this);
        this.toggle = this.toggle.bind(this);
        this.validateNumber = this.validateNumber.bind(this);
        this.reloadCaptcha = this.reloadCaptcha.bind(this);
    }

    validateNumber(evt) {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = evt.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    handleChange(event, setFieldValue) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
        //if (name === 'norek') {
        //    this.props.setNorek(event.target.value);
        //    setFieldValue('BankAccountNumber2', event.target.value);
        //    console.log('set norek');
        //}
        //if (name === 'nama') {
        //    this.props.setNamaPemegangRekening(event.target.value.toUpperCase());
        //    this.setState({ nama: event.target.value.toUpperCase() });
        //    setFieldValue('BankAccountHolderName2', event.target.value);
        //}
        if (name === 'agreement') {
            this.setState({ agreementCheck: event.target.checked });
        }

        if (name === 'agreementBCA') {
            this.setState({ agreementBCA: event.target.checked });
        }

        if (name === 'agreementBO') {
            this.setState({ agreementBO: true })
        }

        localStorage.setItem(name, value);
    }

    SchemaValidation = Yup.object().shape({
        norek: Yup.string().required('No. Rekening tidak boleh koosong'),
    });

    async handleValidateClick(values) {
        console.log(values.BankAccountNumber2);
        if (!this.state.agreementCheck ||
            !this.state.agreementBO ||
            !this.state.agreementBCA ||
            this.state.kepemilikanAsset.length === 0) {
            alert('Mohon isi data dengan lengkap');
            return;
        }

        if (this.state.kepemilikanAsset == "2") {
            alert('Untuk pembukaan rekening yang mempresentasikan pihak lain silakan hubungi customer service kami di nomor 021-83788900 untuk panduan pembukaan account secara offline');
            return;
        }

        try {
            await this.props.requestBankValidation(
                values.BankAccountNumber2,
                values.BankAccountHolderName2,
                values.BankCode2,
                this.state.validationCode
            );

            // Update image hash and clear validation code
            this.setState({
                imageHash: Date.now(),
                validationCode: ''
            });

            // Check for different response scenarios
            const { bcaValidation } = this.props;

            if (bcaValidation.error) {
                // Handle different error codes
                switch (bcaValidation.errorCode) {
                    case 401:
                        alert('Your session expired');
                        window.location.reload();
                        return;

                    case 500:
                        alert('Server error occurred. Please try again later.');
                        return;

                    default:
                        this.setState({ error: true });
                        if (bcaValidation.errorMessage) {
                            alert(bcaValidation.errorMessage);
                        }
                        return;
                }
            }

            // Handle specific response code
            if (bcaValidation.entity && bcaValidation.entity.ResponseCode === "03") {
                alert(bcaValidation.entity.Message);
            }

        } catch (error) {
            console.error('Error in handleValidateClick:', error);
            alert('An unexpected error occurred. Please try again.');
        }
    }

    toggle() {
        this.setState(({ openModal }) => ({ openModal: !openModal }));
    }

    onChangeSelection(e) {
        this.setState({ kepemilikanAsset: e.target.value });
    };

    reloadCaptcha = () => {
        this.setState(({ imageHash: Date.now() }));
    };

    render() {
        // const { success, message } = this.state;


        const imageValidation = "/api/register/image-validation";
        const { bcaValidation, setFieldValue, nowVerifikasiDataPribadi, values, setFieldTouched } = this.props;

        let daftarButton, msgAlert, verifikasiButton;     

        if (bcaValidation && bcaValidation.entity && !bcaValidation.error) {

            if (bcaValidation.entity.ResponseCode === "00") {

                daftarButton = <Button type="button" color="primary" onClick={() => nowVerifikasiDataPribadi(values, setFieldTouched)} className="btn-block">Lanjutkan</Button>;

                // set localstorage bankValidationCode from RefNo
                localStorage.setItem('BankValidationCode', bcaValidation.entity.RefNo);
                setFieldValue('BankValidationCode', bcaValidation.entity.RefNo);
                // this.setState({ bankValidationCode: bcaValidation.entity.RefNo });

            } else {
                daftarButton = null;
            }

            if (bcaValidation.entity.ResponseCode === "00") {
                msgAlert = <Alert color="success">Data bank telah berhasil diverfikasi, silakan klik tombol 'Lanjutkan'.</Alert>
                verifikasiButton = null;
            } else if (bcaValidation.entity.ResponseCode === "01") {
                msgAlert = <Alert color="danger">{bcaValidation.entity.Message}</Alert>;
                verifikasiButton = <Button type="button" color="primary" onClick={() => this.handleValidateClick(values)} className="btn-block" >Verifikasi</Button>;
            } else if (bcaValidation.entity.ResponseCode === "02") {
                msgAlert = <Alert color="danger">{bcaValidation.entity.Message}</Alert>;
            } else if (bcaValidation.entity.ResponseCode === "03") {
                //alert(bcaValidation.entity.Message);
                //window.location.reload();
                verifikasiButton = <Button type="button" color="primary" onClick={() => this.handleValidateClick(values)} className="btn-block" >Verifikasi</Button>;
            } else {
                msgAlert = null;
                verifikasiButton = <Button type="button" color="primary" onClick={() => this.handleValidateClick(values)} className="btn-block" >Verifikasi</Button>;
            }
        } else {
            msgAlert = null;
            verifikasiButton = <Button type="button" color="primary" onClick={() => this.handleValidateClick(values)} className="btn-block" >Verifikasi</Button>;
        }

        return (
            <React.Fragment>
                <Modal isOpen={bcaValidation.isLoading}>
                    <ModalBody className="text-center">
                        <Spinner color="success" /><br />Loading..
                    </ModalBody>
                </Modal>

                {this.state.error ?
                    bcaValidation.entity.errors && typeof bcaValidation.entity.errors === 'object' ?
                        <Modal isOpen={bcaValidation.error}>
                            <ModalHeader size={"sm"}>{bcaValidation.entity.title}</ModalHeader>
                            <ModalBody className="text-center">
                                <ul>
                                    {
                                        Object.keys(bcaValidation.entity.errors).map(function (key) {
                                            return <li className={"text-danger"}>{bcaValidation.entity.errors[key][0]}</li>
                                        }, this)
                                    }
                                </ul>
                            </ModalBody>
                            <ModalFooter>
                                <Button size={"sm"} color="primary" onClick={() => this.setState({ error: false })}>Close</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                    : null}

                <Fade in={true}>
                    {/*<Formik*/}
                    {/*    //onSubmit={this.handleSubmit}*/}
                    {/*    validationSchema={this.SchemaValidation}*/}
                    {/*>*/}

                        {/*<Form autoComplete="off">*/}
                    <UncontrolledAlert color="warning">Sebelum melanjutkan mohon mempersiapkan dokumen pendukung KTP.</UncontrolledAlert>
                            <p className="text-danger"><b>Sebaiknya menggunakan browser Chrome / Firefox / Safari</b></p>
                    <p>Panduan Pembukaan Rekening online <a href="https://yb.co.id/howtoregist" target="__blank">Klik disini</a></p>
                            {msgAlert}

                            <FormGroup tag="fieldset">
                                <legend>Verifikasi Data Rekening BCA</legend>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Nomor Rekening<span className="text-danger">*</span></Label>
                                    <Input tag={Field} type="tel" name="BankAccountNumber2" maxLength="11" bsSize="sm" min="1"
                                        onKeyPress={(e) => this.validateNumber(e)} max="100000000000" />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Nama Pemegang Rekening<span className="text-danger">*</span></Label>
                                            <Input tag={Field} type="text" name="BankAccountHolderName2"  maxLength="40" minLength="5" bsSize="sm"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Kepemilikan Asset<span className="text-danger">*</span></Label>
                                    {bcaValidation.entity ? (
                                            bcaValidation.entity.ResponseCode === "00" ?
                                                <Input type="text" disabled value="Diri Sendiri" bsSize="sm"
                                                />
                                                : <Input type={"select"}
                                                    className="form-control-sm"
                                                    onChange={(e) => this.onChangeSelection(e)}                                                >
                                                    <option value="" >-- Pilih --</option>
                                                    <option selected="selected" value={"1"}>Diri Sendiri</option>
                                                    <option value={"2"}>Merepresentasikan Pihak Lain</option>
                                                </Input>
                                    ) : <Input type={"select"}
                                        className="form-control-sm"
                                        onChange={(e) => this.onChangeSelection(e)}                                                >
                                        <option value="" >-- Pilih --</option>
                                        <option selected="selected" value={"1"}>Diri Sendiri</option>
                                        <option value={"2"}>Merepresentasikan Pihak Lain</option>
                                    </Input> }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {/*<Row>*/}
                                {/*    <Col md="2" sm="5" xs="12">*/}
                                {/*        <FormGroup>*/}
                                {/*            <Label>Kode Keamanan<span className="text-danger">*</span></Label><br />*/}
                                {/*            <img src={imageValidation + '?' + this.state.imageHash} alt="" />*/}
                                {/*            <Button onClick={() => this.reloadCaptcha()} type="button" outline color="info" size="sm">Reload Captcha</Button>*/}
                                {/*            <Input type="text" name="validationCode" value={this.state.validationCode} onChange={this.handleChange} maxLength="4" bsSize="sm" />*/}
                                {/*        </FormGroup>*/}
                                {/*    </Col>*/}
                                {/*    <Col md="5">*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                                <Row>
                                    <Col md="12">
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" name="agreement" onChange={this.handleChange} />
                                                Saya dengan ini memberikan persetujuan kepada PT. Yakin Bertumbuh Sekuritas untuk meminta konfirmasi atas data rekening saya tersebut di atas kepada PT Bank Central Asia Tbk
                                                <span className="text-danger"> *</span>
                                            </Label>
                                        </FormGroup>
                            </Col>
                            <Col md="12">
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="agreementBCA" onChange={this.handleChange} />
                                        Saya dengan ini menyatakan setuju untuk mematuhi Ketentuan Tambahan sebagai pemilik RDN BCA, Ketentuan Tabungan Prestasi (Tapres) BCA dan Ketentuan e-Statement RDN BCA
                                        <span className="text-danger"> *</span>
                                    </Label>
                                </FormGroup>
                            </Col>
                                    <Col md="12">
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" name="agreementBO" onChange={this.handleChange} />
                                                Saya Dengan ini Menyatakan bahwa saya bertindak atas diri sendiri dan bukan untuk kepentingan orang lain (beneficiary owner)
                                                <span className="text-danger"> *</span>
                                            </Label>
                                        </FormGroup>
                                    </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <span>Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum RDN PT Bank Central Asia Tbk. "BCA" dapat diakses pada website resmi BCA https://www.bca.id/rdnbca</span></Col>
                                                    </Row>
                                <Row>
                                    <Col md="3" xs="12" sm="12">
                                        {verifikasiButton}{daftarButton}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        Estimasi pembuatan akun 2 x 24 Jam Kerja*<br />
                                        Syarat dan Ketentuan Berlaku*
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <br />
                                        <a href="https://www.bca.co.id/id/Individu/layanan/e-banking/BCA-Mobile/Buat-Rekening">
                                            Belum mempunyai rekening BCA? Klik disini
                                        </a>
                                    </Col>
                                </Row>
                            </FormGroup>
                    {/*    </Form>*/}
                    {/*</Formik>*/}
                </Fade>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestBankValidation: bankValidationActions.requestBankValidation
    }, dispatch);
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(BankValidation));



// WEBPACK FOOTER //
// ./src/components/BankValidation.js